import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  wrenchCloseButton: ({ component }) => {
    const componentSpecificStyles =
      component === 'badge'
        ? {
            top: '2px',
            right: theme.spacing[1],
            padding: theme.spacing[1],
          }
        : {
            right: theme.spacing[1],
            top: theme.spacing[1],
            padding: theme.spacing[2],
          };

    return {
      ...componentSpecificStyles,
      fontSize: theme.fontSize.body,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      position: 'absolute',
      borderRadius: '0',
      textDecoration: 'none',
      background: 'transparent',
      border: 'none',

      '&:hover': {
        transition: 'none',
        textDecoration: 'none',
      },
      '&:active': {
        transition: 'none',
        outline: 'none',
      },
    };
  },
}));

export default useStyles;
